/* =============================================================
   LUMI CUSTOMISER — logique vanilla, multi-instance
   Les @font-face sont generes par Shopify via le filtre font_face
   (declares au top de la section Liquid). Pas de lazy-load custom.
   Backend Worker integration : si data-worker-url est defini,
   cree un produit Shopify unique par design (image custom au checkout).
   ============================================================= */
(function () {
  'use strict';

  /* Fontes incompatibles avec Petit 40 cm (trop condensees / hauteur ecrasee).
     Modifier ici pour adapter la regle de compatibilite. */
  var INCOMPATIBLE_SMALL = ['Bebas Neue', 'Oswald', 'Bungee', 'Anton', 'Archivo Black'];

  /* Couleurs - label fallback pour les line item properties (visible dans le panier).
     Le vrai label vient du DOM (data-* du wrapper) si dispo. */
  var COLOR_LABELS = {
    red: 'Rouge', coral: 'Corail', orange: 'Orange', yellow: 'Jaune',
    warm_white: 'Blanc chaud', white: 'Blanc', green: 'Vert', ice_blue: 'Bleu glacé',
    blue: 'Bleu', violet: 'Violet', pink: 'Rose', rgb: 'RGB'
  };

  var SIZE_CM = { small: 40, medium: 60, large: 80, xl: 100 };

  /* ---------- Helpers ---------- */

  function moneyFromCents(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* Extrait les chiffres finaux d une string. Accepte un ID brut OU une URL admin complete. */
  function extractVariantId(value) {
    if (!value) return null;
    var match = String(value).match(/(\d+)\s*$/);
    return match ? parseInt(match[1], 10) : null;
  }

  function isFontIncompatibleWithSize(font, size) {
    return size === 'small' && INCOMPATIBLE_SMALL.indexOf(font) !== -1;
  }

  /* ---------- Init principal ---------- */

  function initInstance(root) {
    var defaultFont = root.dataset.defaultFont || 'Poppins';
    var defaultTile = root.querySelector('[data-lumi-cust-font="' + defaultFont + '"]');
    var defaultFallback = defaultTile ? (defaultTile.getAttribute('data-lumi-cust-font-fallback') || 'sans-serif') : 'sans-serif';
    var defaultCat = defaultTile ? defaultTile.getAttribute('data-lumi-cust-font-cat') : 'cursive';

    var initialPreview = root.querySelector('[data-lumi-cust-neon-text]');
    var placeholderText = initialPreview ? initialPreview.textContent.trim() : 'Votre texte';

    var state = {
      text: '',
      placeholderText: placeholderText,
      font: defaultFont,
      fontFallback: defaultFallback,
      fontCat: defaultCat,
      color: 'violet',
      colorHex: '#6136FF',
      isRgb: false,
      size: root.dataset.popularSize || 'medium',
      power: true,
      widthCm: SIZE_CM[root.dataset.popularSize] || 60
    };

    applyFontSelection(root, state);
    applyColorSelection(root, state);
    applySizeSelection(root, state);
    validateSizes(root, state);
    updateCounter(root, state);
    updatePrice(root, state);
    updatePreviewText(root, state);
    requestAnimationFrame(function () { updateDimensions(root, state); });
    validate(root, state);

    /* === Events === */

    var textarea = root.querySelector('[data-lumi-cust-text]');
    var debouncedPreview = debounce(function () {
      updatePreviewText(root, state);
      updateDimensions(root, state);
      updateFontPreviewSamples(root, state);
      updatePrice(root, state);
      validate(root, state);
    }, 150);
    if (textarea) {
      textarea.addEventListener('input', function () {
        state.text = textarea.value;
        updateCounter(root, state);
        updateLineBreakSuggestion(root, state);
        debouncedPreview();
      });
    }

    /* === Suggestion de saut de ligne automatique (Option B) ===
       Apparait quand le texte > 20 chars et n a pas encore de saut de ligne.
       Le bouton insere un \n au meilleur endroit (espace le plus proche du milieu). */
    var linebreakBtn = root.querySelector('[data-lumi-cust-linebreak-action]');
    if (linebreakBtn && textarea) {
      linebreakBtn.addEventListener('click', function () {
        var current = textarea.value;
        var splitPos = findBestSplitPosition(current);
        if (splitPos === -1) return; /* pas d espace utilisable */
        textarea.value = current.slice(0, splitPos) + '\n' + current.slice(splitPos + 1);
        state.text = textarea.value;
        updateCounter(root, state);
        updateLineBreakSuggestion(root, state);
        updatePreviewText(root, state);
        updateDimensions(root, state);
        textarea.focus();
      });
    }

    root.querySelectorAll('[data-lumi-cust-font]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        state.font = tile.getAttribute('data-lumi-cust-font');
        state.fontFallback = tile.getAttribute('data-lumi-cust-font-fallback') || 'sans-serif';
        state.fontCat = tile.getAttribute('data-lumi-cust-font-cat');
        applyFontSelection(root, state);
        updatePreviewText(root, state);
        requestAnimationFrame(function () { updateDimensions(root, state); });
        validateSizes(root, state);
        validate(root, state);
      });
    });

    root.querySelectorAll('[data-lumi-cust-color]').forEach(function (c) {
      c.addEventListener('click', function () {
        state.color = c.getAttribute('data-lumi-cust-color');
        state.colorHex = c.getAttribute('data-lumi-cust-color-hex');
        state.isRgb = state.color === 'rgb';
        state.colorTouched = true;  /* marque que l user a explicitement choisi (le placeholder doit alors prendre cette couleur) */
        applyColorSelection(root, state);
        updatePreviewText(root, state);
        updatePrice(root, state);
        validate(root, state);
      });
    });

    root.querySelectorAll('[data-lumi-cust-size]').forEach(function (s) {
      s.addEventListener('click', function () {
        if (s.classList.contains('lumi-cust-size--disabled')) return;
        state.size = s.getAttribute('data-lumi-cust-size');
        state.widthCm = parseInt(s.getAttribute('data-lumi-cust-size-cm'), 10);
        applySizeSelection(root, state);
        updateDimensions(root, state);
        updatePrice(root, state);
        validate(root, state);
      });
    });

    root.querySelectorAll('[data-lumi-cust-mockup-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = root.querySelector('[data-lumi-cust-mockup-img]');
        var src = t.getAttribute('data-mockup-src');
        if (!src) return;
        if (img && img.tagName === 'IMG') {
          img.src = src;
          img.classList.remove('lumi-cust-mockup-img--empty');
        } else if (img) {
          var newImg = document.createElement('img');
          newImg.className = 'lumi-cust-mockup-img';
          newImg.setAttribute('data-lumi-cust-mockup-img', '');
          newImg.src = src;
          newImg.alt = '';
          newImg.width = 1200;
          newImg.height = 800;
          newImg.loading = 'lazy';
          img.parentNode.replaceChild(newImg, img);
        }
        root.querySelectorAll('[data-lumi-cust-mockup-thumb]').forEach(function (x) {
          x.classList.toggle('is-active', x === t);
        });
      });
    });

    var toggle = root.querySelector('[data-lumi-cust-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        state.power = !state.power;
        toggle.setAttribute('aria-pressed', state.power ? 'true' : 'false');
        root.dataset.power = state.power ? 'on' : 'off';
      });
    }

    var cta = root.querySelector('[data-lumi-cust-add-to-cart]');
    if (cta) {
      cta.addEventListener('click', function () { addToCart(root, state, cta); });
    }
  }

  /* ---------- Render & state apply ---------- */

  function updateCounter(root, state) {
    var counter = root.querySelector('[data-lumi-cust-counter]');
    if (!counter) return;
    var max = parseInt(root.dataset.maxChars, 10) || 60;
    counter.textContent = state.text.length + ' / ' + max;
    counter.classList.toggle('is-near-limit', state.text.length >= max * 0.9);
  }

  /* Affiche/masque la suggestion de saut de ligne.
     Conditions :
     - texte > 20 chars (seuil ou un neon mono-ligne devient illisible / trop petit)
     - aucun \n deja present (sinon le user a deja gere)
     - au moins un espace dans le texte (sinon split impossible) */
  function updateLineBreakSuggestion(root, state) {
    var suggestion = root.querySelector('[data-lumi-cust-linebreak-suggestion]');
    if (!suggestion) return;
    var txt = state.text || '';
    var shouldShow = txt.length > 20 && txt.indexOf('\n') === -1 && txt.indexOf(' ') !== -1;
    suggestion.hidden = !shouldShow;
  }

  /* Trouve la position d espace la plus proche du milieu du texte pour split en 2 lignes equilibrees.
     Retourne -1 si pas d espace utilisable. */
  function findBestSplitPosition(text) {
    if (!text || text.indexOf(' ') === -1) return -1;
    var midpoint = Math.floor(text.length / 2);
    var bestPos = -1;
    var bestDistance = Infinity;
    for (var i = 0; i < text.length; i++) {
      if (text[i] === ' ') {
        var distance = Math.abs(i - midpoint);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestPos = i;
        }
      }
    }
    return bestPos;
  }

  function updatePreviewText(root, state) {
    var txt = root.querySelector('[data-lumi-cust-neon-text]');
    if (!txt) return;

    var hasText = state.text && state.text.trim().length > 0;
    var displayText = hasText ? state.text : (state.placeholderText || 'Votre texte');
    txt.textContent = displayText;
    txt.style.fontFamily = '"' + state.font + '", ' + state.fontFallback + ', "Poppins", sans-serif';

    /* Marque que le neon-text affiche le placeholder (pas du contenu user reel).
       Permet a la CSS d agrandir le placeholder sur mobile (UX iPhone : visible des l arrivee). */
    txt.classList.toggle('lumi-cust-neon-text--placeholder', !hasText);

    /* Le placeholder est en RGB SEULEMENT tant que l user n a pas encore touche aux couleurs.
       Des qu il clique une couleur, le placeholder prend cette couleur (UX intuitive : tester
       les couleurs avant d ecrire son texte). */
    var useRgbVisual = state.isRgb || (!hasText && !state.colorTouched);

    if (useRgbVisual) {
      txt.classList.add('lumi-cust-neon-text--rgb');
      txt.style.color = '';
      txt.style.textShadow = '';
      root.style.setProperty('--lumi-cust-color', '#B45FFF');
    } else {
      txt.classList.remove('lumi-cust-neon-text--rgb');
      txt.style.color = state.colorHex;
      txt.style.textShadow = '';
      root.style.setProperty('--lumi-cust-color', state.colorHex);
    }
  }

  function updateFontPreviewSamples(root, state) {
    var sample = state.text.trim();
    root.querySelectorAll('[data-lumi-cust-font-preview]').forEach(function (el) {
      el.textContent = sample ? sample.slice(0, 12) : (el.dataset.defaultSample || el.textContent);
    });
  }

  function applyFontSelection(root, state) {
    root.querySelectorAll('[data-lumi-cust-font]').forEach(function (t) {
      t.classList.toggle('is-selected', t.getAttribute('data-lumi-cust-font') === state.font);
    });
  }

  function applyColorSelection(root, state) {
    root.querySelectorAll('[data-lumi-cust-color]').forEach(function (c) {
      var match = c.getAttribute('data-lumi-cust-color') === state.color;
      c.classList.toggle('is-selected', match);
      c.setAttribute('aria-checked', match ? 'true' : 'false');
    });
    var note = root.querySelector('[data-lumi-cust-rgb-note]');
    if (note) note.hidden = !state.isRgb;
  }

  function applySizeSelection(root, state) {
    root.querySelectorAll('[data-lumi-cust-size]').forEach(function (s) {
      var match = s.getAttribute('data-lumi-cust-size') === state.size;
      s.classList.toggle('is-selected', match);
      s.setAttribute('aria-checked', match ? 'true' : 'false');
    });
  }

  function validateSizes(root, state) {
    root.querySelectorAll('[data-lumi-cust-size]').forEach(function (s) {
      var sz = s.getAttribute('data-lumi-cust-size');
      var incompat = isFontIncompatibleWithSize(state.font, sz);
      s.classList.toggle('lumi-cust-size--disabled', incompat);
      var msg = s.querySelector('.lumi-cust-size-disabled-msg');
      if (msg) msg.hidden = !incompat;
    });
    if (isFontIncompatibleWithSize(state.font, state.size)) {
      state.size = 'medium';
      state.widthCm = SIZE_CM.medium;
      applySizeSelection(root, state);
    }
  }

  function updateDimensions(root, state) {
    var widthEl = root.querySelector('[data-lumi-cust-dim-width]');
    var txt = root.querySelector('[data-lumi-cust-neon-text]');
    var mockup = root.querySelector('.lumi-cust-mockup');
    if (!txt || !widthEl) return;

    var widthCm = SIZE_CM[state.size];

    /* Echelle de texte proportionnelle a la taille reelle (60cm = baseline 1.0).
       Petit 40cm = 0.67, Moyen 60cm = 1.0, Grand 80cm = 1.33, XL 100cm = 1.67.
       PUIS fit-to-container : si le texte deborde du mockup, on shrink pour fit. */
    var baseScale = widthCm / 60;

    var isMobile = window.innerWidth <= 900;

    if (isMobile) {
      /* ===== STRATEGIE MOBILE HYBRIDE : MESURE DOM PRIORITAIRE, HEURISTIQUE FALLBACK =====

         Problematique :
         - L heuristique pure 1.6x est trop conservative pour les polices etroites (cursive)
           -> texte ridicule (5px) alors que 28px tiendrait
         - La mesure DOM seule est trompee pendant le font swap (1re mesure sur fallback narrow)
           -> overflow apres le swap quand la vraie police (wide) prend le relais

         Solution : on detecte si la police EST DEJA CHARGEE avant de mesurer.
         - Si police chargee (cache, ou re-selection apres 1ere utilisation) : mesure DOM directe
           = sizing OPTIMAL adapte a la police reelle (cursive grosse, wide ajustee)
         - Si police PAS chargee (1ere utilisation) : heuristique conservative en attendant
           le load (evite overflow), puis bascule mesure DOM des que la police est prete

         Resultat :
         - Apres 1ere utilisation, toute interaction = mesure precise immediate (zero spring)
         - 1ere utilisation d une police = passe rapide heuristique -> mesure (1 transition unique)
         - Jamais d overflow grace au heuristique fallback */

      function applyMeasurementShrink() {
        if (!mockup) return;
        root.style.setProperty('--lumi-cust-text-scale', baseScale.toFixed(3));
        void txt.offsetWidth;

        var mockupRect = mockup.getBoundingClientRect();
        var textRect = txt.getBoundingClientRect();
        if (mockupRect.width <= 0 || textRect.width <= 0) return;

        /* Marges defensives mobile : 80% width, 65% height (entre desktop 85/70 et l ancien 75/60) */
        var safeWidth = mockupRect.width * 0.80;
        var safeHeight = mockupRect.height * 0.65;

        var widthRatio = safeWidth / textRect.width;
        var heightRatio = safeHeight / textRect.height;
        var fitRatio = Math.min(widthRatio, heightRatio, 1);

        var finalScale = baseScale * fitRatio;
        root.style.setProperty('--lumi-cust-text-scale', finalScale.toFixed(3));
      }

      function applyHeuristicShrink() {
        if (!mockup) return;
        var lines = (state.text || '').split('\n');
        var longestLine = '';
        for (var li = 0; li < lines.length; li++) {
          if (lines[li].length > longestLine.length) longestLine = lines[li];
        }
        var textLength = longestLine.length || 1;

        var mockupRect = mockup.getBoundingClientRect();
        if (mockupRect.width <= 0) return;

        var baseFontSize = 32;
        var charWidthFactor = 1.6;
        var safeWidth = mockupRect.width * 0.72;

        var estimatedWidth = textLength * baseFontSize * baseScale * charWidthFactor;
        var fitRatio = Math.min(safeWidth / estimatedWidth, 1);
        var finalScale = baseScale * fitRatio;
        root.style.setProperty('--lumi-cust-text-scale', finalScale.toFixed(3));
      }

      /* Verifie si la police selectionnee est DEJA chargee (donc mesure DOM fiable). */
      var fontIsLoaded = false;
      try {
        if (document.fonts && typeof document.fonts.check === 'function') {
          fontIsLoaded = document.fonts.check('16px "' + state.font + '"');
        }
      } catch (e) { /* document.fonts.check throws sur certains noms, on traite comme non charge */ }

      if (fontIsLoaded) {
        /* Police deja chargee : mesure DOM directe = sizing optimal pour cette police. */
        requestAnimationFrame(applyMeasurementShrink);
      } else {
        /* Police pas encore chargee : heuristique conservative en attendant pour eviter
           tout overflow. Puis on attend le load et on bascule sur la mesure precise. */
        applyHeuristicShrink();

        if (document.fonts && typeof document.fonts.load === 'function') {
          try {
            document.fonts.load('16px "' + state.font + '"').then(function () {
              requestAnimationFrame(applyMeasurementShrink);
            }).catch(function () {
              /* Si load echoue, on garde la heuristique */
            });
          } catch (e) { /* same */ }
        }

        /* Filet de securite iOS Safari : 600ms quoi qu il arrive on re-mesure
           (au cas ou document.fonts.load ne resolve pas correctement) */
        setTimeout(function () {
          requestAnimationFrame(applyMeasurementShrink);
        }, 600);
      }
    } else {
      /* ===== STRATEGIE DESKTOP : MESURE DOM + MULTI-PASS (logique originale conservee) ===== */
      function computeAndApplyShrink() {
        if (!mockup) return;
        root.style.setProperty('--lumi-cust-text-scale', baseScale.toFixed(3));
        void txt.offsetWidth;

        var mockupRect = mockup.getBoundingClientRect();
        var textRect = txt.getBoundingClientRect();
        if (mockupRect.width <= 0 || textRect.width <= 0) return;

        var safeWidth = mockupRect.width * 0.85;
        var safeHeight = mockupRect.height * 0.70;

        var widthRatio = safeWidth / textRect.width;
        var heightRatio = safeHeight / textRect.height;
        var fitRatio = Math.min(widthRatio, heightRatio, 1);

        var finalScale = baseScale * fitRatio;
        root.style.setProperty('--lumi-cust-text-scale', finalScale.toFixed(3));
      }

      requestAnimationFrame(computeAndApplyShrink);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          requestAnimationFrame(computeAndApplyShrink);
        });
      }
      setTimeout(function () { requestAnimationFrame(computeAndApplyShrink); }, 350);
    }

    var r = txt.getBoundingClientRect();

    widthEl.textContent = widthCm + ' cm';

    if (mockup) {
      var mockupRect = mockup.getBoundingClientRect();
      var hasThumbs = !!root.querySelector('.lumi-cust-mockup-thumbs');
      var bottomReserve = hasThumbs ? 64 : 20;
      var maxTop = mockupRect.height - bottomReserve;
      var textBottomRel = r.bottom - mockupRect.top;
      var widthLabelTop = Math.min(textBottomRel + 10, maxTop);
      widthEl.style.bottom = 'auto';
      widthEl.style.top = widthLabelTop + 'px';
      widthEl.style.left = '50%';
      widthEl.style.transform = 'translateX(-50%)';
    }

    state.widthCm = widthCm;
  }

  function updatePrice(root, state) {
    /* Prix par taille + option RGB +25% si selectionne + LUMI10 -10% promo.
       REVERT du double anchoring : le prix barre conseille (MSRP) n est pas DGCCRF-compliant
       en France (Article L.112-1-1 du Code de la consommation : le prix barre doit etre le prix
       le plus bas pratique dans les 30 derniers jours). On retient seulement le mecanisme LUMI10. */
    var key = 'price' + state.size.charAt(0).toUpperCase() + state.size.slice(1);
    var basePrice = parseInt(root.dataset[key], 10) || 0;
    var rgbPercent = parseInt(root.dataset.rgbSurchargePercent, 10);
    if (isNaN(rgbPercent)) rgbPercent = 25;
    var rgbMultiplier = state.isRgb ? (1 + rgbPercent / 100) : 1;
    var totalOld = Math.round(basePrice * rgbMultiplier);
    var promoPct = parseInt(root.dataset.promoPercent, 10) || 0;
    var totalNew = Math.round(totalOld * (100 - promoPct) / 100);

    state.basePriceCents = totalOld;
    state.finalPriceCents = totalNew;

    var recapEl = root.querySelector('[data-lumi-cust-recap-price]');
    if (recapEl) recapEl.textContent = moneyFromCents(totalNew);

    var oldEl = root.querySelector('[data-lumi-cust-price-old]');
    var newEl = root.querySelector('[data-lumi-cust-price-new]');
    if (oldEl && newEl) {
      if (promoPct > 0) {
        oldEl.textContent = moneyFromCents(totalOld);
        newEl.textContent = moneyFromCents(totalNew);
        oldEl.hidden = false;
      } else {
        oldEl.hidden = true;
        newEl.textContent = moneyFromCents(totalOld);
      }
    }

    /* Sync Klarna placement(s) avec le prix final.
       data-purchase-amount est en centimes (format Klarna). */
    syncKlarnaPlacement(root, totalNew);
  }

  /* Update Klarna On-Site Messaging avec le montant total apres promo */
  function syncKlarnaPlacement(root, amountCents) {
    var wrapper = root.querySelector('[data-lumi-cust-app-blocks]');
    if (wrapper) {
      wrapper.setAttribute('data-lumi-cust-amount', String(amountCents));
    }
    /* Met a jour chaque element klarna-placement dans la section */
    root.querySelectorAll('klarna-placement').forEach(function (el) {
      el.setAttribute('data-purchase-amount', String(amountCents));
    });
    /* Demande a Klarna SDK de re-render si charge */
    if (typeof window.Klarna !== 'undefined'
        && window.Klarna.OnsiteMessaging
        && typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
      try { window.Klarna.OnsiteMessaging.refresh(); } catch (e) { /* silencieux */ }
    }
  }

  function validate(root, state) {
    var cta = root.querySelector('[data-lumi-cust-add-to-cart]');
    var help = root.querySelector('[data-lumi-cust-cta-help]');
    if (!cta) return;

    var hasText = state.text && state.text.trim().length > 0;
    var sizeOk = !isFontIncompatibleWithSize(state.font, state.size);

    if (hasText && sizeOk) {
      cta.disabled = false;
      if (help) { help.hidden = true; help.textContent = ''; }
      return;
    }

    cta.disabled = true;
    if (help) {
      var msg = !hasText
        ? (root.dataset.i18nHelpEmpty || '')
        : (root.dataset.i18nHelpIncompat || '');
      help.textContent = msg;
      help.hidden = !msg;
    }
  }

  /* ---------- Capture preview image (canvas natif) ----------
     v2 : MULTI-LIGNES (respect des \n).
     Bug critique avant : ctx.fillText() ignore les \n et rend tout sur 1 ligne,
     forcant le shrink a fond pour fit la largeur => texte ridicule + saut de ligne perdu.
     Le client voyait "Cheval Blanc Opening Night" sur 1 ligne minuscule au lieu de 2 lignes lisibles.
     Resultat : il ne reconnaissait pas son design dans le cart => abandon panier. */

  function capturePreviewImage(state) {
    try {
      var canvas = document.createElement('canvas');
      /* Resolution 2x (960x480) pour rendu retina-quality dans les thumbnails cart/checkout. */
      var W = 960, H = 480;
      canvas.width = W;
      canvas.height = H;
      var ctx = canvas.getContext('2d');
      if (!ctx) return null;

      /* Background sombre + glow violet ambiant (style mockup) */
      ctx.fillStyle = '#0a0a0a';
      ctx.fillRect(0, 0, W, H);
      var bgGrad = ctx.createRadialGradient(W / 2, H / 2, 100, W / 2, H / 2, W);
      bgGrad.addColorStop(0, 'rgba(97, 54, 255, 0.08)');
      bgGrad.addColorStop(1, 'rgba(0, 0, 0, 0)');
      ctx.fillStyle = bgGrad;
      ctx.fillRect(0, 0, W, H);

      var text = (state.text && state.text.trim()) || state.placeholderText || 'Votre texte';
      var fontFamily = state.font || 'Poppins';
      var fontFallback = state.fontFallback || 'sans-serif';

      /* === SPLIT MULTI-LIGNES === Les \n du textarea deviennent de vraies lignes separees. */
      var lines = text.split('\n').map(function (l) { return l || ' '; }); /* preserve les lignes vides */
      var lineCount = lines.length;

      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      /* === FIT-TO-CONTAINER : calcule la font-size optimale ===
         On cherche la plus grande taille telle que :
         - la ligne la plus large rentre dans W - padding
         - la hauteur totale (N lines x lineHeight) rentre dans H - padding */
      var maxFontSize = 160;
      var minFontSize = 32;
      var fontSize = maxFontSize;
      var paddingX = 120;
      var paddingY = 80;
      var lineHeightRatio = 1.15;

      do {
        ctx.font = fontSize + 'px "' + fontFamily + '", ' + fontFallback + ', sans-serif';
        /* Largeur = la ligne la plus large parmi toutes */
        var maxLineWidth = 0;
        for (var li = 0; li < lineCount; li++) {
          var lw = ctx.measureText(lines[li]).width;
          if (lw > maxLineWidth) maxLineWidth = lw;
        }
        /* Hauteur totale du bloc multi-lignes */
        var totalHeight = lineCount * fontSize * lineHeightRatio;
        if (maxLineWidth < W - paddingX && totalHeight < H - paddingY) break;
        fontSize -= 2;
      } while (fontSize > minFontSize);

      /* === COULEUR : RGB gradient ou solid color === */
      var textFill;
      if (state.isRgb) {
        var grad = ctx.createLinearGradient(0, 0, W, 0);
        grad.addColorStop(0,    '#ff2b2b');
        grad.addColorStop(0.18, '#ff8a1f');
        grad.addColorStop(0.36, '#ffe14a');
        grad.addColorStop(0.54, '#3ee27a');
        grad.addColorStop(0.72, '#3ee4ff');
        grad.addColorStop(0.88, '#6136FF');
        grad.addColorStop(1,    '#ff60b8');
        textFill = grad;
      } else {
        textFill = state.colorHex || '#B45FFF';
      }

      var glowColor = state.isRgb ? '#B45FFF' : (state.colorHex || '#B45FFF');
      ctx.shadowColor = glowColor;

      /* === DESSINE CHAQUE LIGNE avec multi-pass glow ===
         Centre vertical du bloc complet = H/2. La 1re ligne commence plus haut, les suivantes descendent. */
      var lineHeight = fontSize * lineHeightRatio;
      var totalBlockHeight = lineCount * lineHeight;
      /* StartY = position du CENTRE de la 1re ligne (textBaseline middle).
         On centre le bloc puis on ajoute la moitie d une lineHeight pour atterrir au milieu de la 1re ligne. */
      var startY = (H - totalBlockHeight) / 2 + lineHeight / 2;
      var x = W / 2;

      ctx.fillStyle = textFill;

      for (var i = 0; i < lineCount; i++) {
        var lineY = startY + i * lineHeight;
        /* 4 passes de shadowBlur croissant pour le glow neon (style mockup) */
        ctx.shadowBlur = 12;  ctx.fillText(lines[i], x, lineY);
        ctx.shadowBlur = 32;  ctx.fillText(lines[i], x, lineY);
        ctx.shadowBlur = 64;  ctx.fillText(lines[i], x, lineY);
        ctx.shadowBlur = 0;   ctx.fillText(lines[i], x, lineY);
      }

      return canvas.toDataURL('image/jpeg', 0.85);
    } catch (e) {
      console.warn('[lumi-cust] capturePreviewImage failed', e);
      return null;
    }
  }

  /* ---------- Worker backend : creation produit dynamique ---------- */

  function callWorkerCreateDesign(workerUrl, state, previewDataUrl) {
    var payload = {
      imageBase64: previewDataUrl,
      text: state.text || state.placeholderText || '',
      font: state.font || 'Poppins',
      color: state.isRgb ? 'RGB' : state.color,
      size: state.size,
      widthCm: state.widthCm || 0,
      isRgb: !!state.isRgb,
      priceCents: state.basePriceCents || 0
    };
    return fetch(workerUrl.replace(/\/$/, '') + '/create-design', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (e) {
            console.warn('[lumi-cust] Worker error response', r.status, e);
            return null;
          }).catch(function () { return null; });
        }
        return r.json();
      })
      .catch(function (e) {
        console.warn('[lumi-cust] Worker fetch failed', e);
        return null;
      });
  }

  /* ---------- Add to cart ---------- */

  function addToCart(root, state, ctaBtn) {
    /* Capture du visuel UPFRONT (servira pour Worker et fallback property) */
    var previewDataUrl = capturePreviewImage(state);

    var workerUrl = (root.dataset.workerUrl || '').trim();
    var workerPromise;

    if (workerUrl && previewDataUrl) {
      console.log('[lumi-cust] Calling Worker at', workerUrl);
      workerPromise = callWorkerCreateDesign(workerUrl, state, previewDataUrl);
    } else {
      console.log('[lumi-cust] No worker URL, using static variant fallback');
      workerPromise = Promise.resolve(null);
    }

    /* UI loading state */
    var label = ctaBtn.querySelector('.lumi-cust-cta-label');
    var spinner = ctaBtn.querySelector('.lumi-cust-cta-spinner');
    if (label) label.style.opacity = '0.5';
    if (spinner) spinner.hidden = false;
    ctaBtn.disabled = true;

    workerPromise.then(function (workerResult) {
      var variantId;
      var isDynamic = false;

      if (workerResult && workerResult.success && workerResult.variantId) {
        console.log('[lumi-cust] Worker success: dynamic variantId', workerResult.variantId);
        variantId = parseInt(workerResult.variantId, 10);
        isDynamic = true;
      } else {
        var key = 'variant' + state.size.charAt(0).toUpperCase() + state.size.slice(1);
        variantId = extractVariantId(root.dataset[key]);
        console.log('[lumi-cust] Fallback to static variantId', variantId);
      }

      if (!variantId) {
        console.warn('[lumi-cust] Aucun variant ID disponible (Worker KO + fallback vide)');
        var helpEl = root.querySelector('[data-lumi-cust-cta-help]');
        if (helpEl) {
          helpEl.hidden = false;
          helpEl.textContent = root.dataset.i18nCartError || 'Erreur ajout au panier';
        }
        if (label) label.style.opacity = '';
        if (spinner) spinner.hidden = true;
        ctaBtn.disabled = false;
        return;
      }

      doAddToCart(root, state, ctaBtn, variantId, isDynamic, previewDataUrl, label, spinner);
    });
  }

  function doAddToCart(root, state, ctaBtn, variantId, isDynamic, previewDataUrl, label, spinner) {

    var tile = root.querySelector('[data-lumi-cust-font="' + state.font + '"]');
    var fontLabel = tile ? (tile.getAttribute('data-lumi-cust-font-label') || state.font) : state.font;

    var colorWrap = root.querySelector('[data-lumi-cust-color="' + state.color + '"]');
    var colorLabelEl = colorWrap ? colorWrap.querySelector('.lumi-cust-color-label') : null;
    var colorLabel = state.isRgb
      ? (colorLabelEl ? colorLabelEl.textContent.trim() : 'RGB')
      : (colorLabelEl ? colorLabelEl.textContent.trim() : (COLOR_LABELS[state.color] || state.color));

    var sizeBtn = root.querySelector('[data-lumi-cust-size="' + state.size + '"]');
    var sizeNameEl = sizeBtn ? sizeBtn.querySelector('.lumi-cust-size-name') : null;
    var sizeLabel = sizeNameEl
      ? sizeNameEl.textContent.trim() + ' (' + SIZE_CM[state.size] + ' cm)'
      : (state.size + ' (' + SIZE_CM[state.size] + ' cm)');

    var props = {};
    props[root.dataset.i18nPropText || 'Texte'] = state.text;
    props[root.dataset.i18nPropFont || 'Police'] = fontLabel;
    props[root.dataset.i18nPropColor || 'Couleur'] = colorLabel;
    props[root.dataset.i18nPropSize || 'Taille'] = sizeLabel;
    props[root.dataset.i18nPropWidth || 'Largeur'] = state.widthCm + ' cm';
    props[root.dataset.i18nPropMode || 'Mode couleur'] = state.isRgb
      ? (root.dataset.i18nPropModeRgb || 'RGB')
      : (root.dataset.i18nPropModeSingle || 'Single');
    props._design_signature = state.font + '|' + state.color + '|' + state.size;

    /* Property cachee pour fallback : permet au cart template d afficher l image
       meme si le mode dynamic product n est pas utilise. */
    if (previewDataUrl) {
      props._design_image = previewDataUrl;
    }
    if (isDynamic) {
      props._design_mode = 'dynamic-product';
    }

    var items = [{
      id: variantId,
      quantity: 1,
      properties: props
    }];

    /* En mode statique, on ajoute la variant RGB Upgrade en bonus si applicable.
       En mode dynamic product, le prix est deja inclus dans le variant cree. */
    if (!isDynamic && state.isRgb) {
      var rgbVariantId = extractVariantId(root.dataset.variantRgb);
      if (rgbVariantId) {
        items.push({
          id: rgbVariantId,
          quantity: 1,
          properties: { _ref_neon: state.text }
        });
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        /* Redirige vers /checkout par defaut (configurable via data-redirect-to-cart="true").
           Auto-apply du code promo via parametre ?discount= */
        var redirectToCart = root.dataset.redirectToCart === 'true';
        var promoCode = (root.dataset.promoCode || '').trim();
        var base = redirectToCart
          ? (root.dataset.i18nCartUrl || '/cart')
          : '/checkout';
        var destination = base;
        if (promoCode) {
          destination += (base.indexOf('?') === -1 ? '?' : '&') + 'discount=' + encodeURIComponent(promoCode);
        }
        window.location.href = destination;
      })
      .catch(function (err) {
        console.error('[lumi-cust] Cart error', err);
        var help = root.querySelector('[data-lumi-cust-cta-help]');
        if (help) {
          help.hidden = false;
          help.textContent = root.dataset.i18nCartError || 'Erreur ajout au panier';
        }
        if (label) label.style.opacity = '';
        if (spinner) spinner.hidden = true;
        ctaBtn.disabled = false;
      });
  }

  /* ---------- Drag du neon (desktop only, pointer: fine) ---------- */

  function setupNeonDrag(root) {
    /* Active uniquement sur device avec pointeur precis (souris)
       ET ecran > 900px (pas mobile). */
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (window.matchMedia('(max-width: 900px)').matches) return;

    var neonText = root.querySelector('[data-lumi-cust-neon-text]');
    var mockup = root.querySelector('.lumi-cust-mockup');
    if (!neonText || !mockup) return;

    /* Active les pointer-events et cursor sur le texte (override CSS pointer-events: none du parent) */
    neonText.style.pointerEvents = 'auto';
    neonText.style.cursor = 'grab';
    neonText.style.userSelect = 'none';
    neonText.style.touchAction = 'none';

    var offset = { x: 0, y: 0 };
    var start = { x: 0, y: 0 };
    var isDragging = false;
    var savedTransition = '';

    function clampOffset(dx, dy) {
      var mockupRect = mockup.getBoundingClientRect();
      var textRect = neonText.getBoundingClientRect();
      /* Le texte doit rester dans les limites du mockup avec 12px de marge */
      var margin = 12;
      var maxX = Math.max(0, (mockupRect.width - textRect.width) / 2 - margin);
      var maxY = Math.max(0, (mockupRect.height - textRect.height) / 2 - margin);
      return {
        x: Math.max(-maxX, Math.min(maxX, dx)),
        y: Math.max(-maxY, Math.min(maxY, dy))
      };
    }

    function onMouseDown(e) {
      e.preventDefault();
      isDragging = true;
      start.x = e.clientX - offset.x;
      start.y = e.clientY - offset.y;
      neonText.style.cursor = 'grabbing';
      savedTransition = neonText.style.transition;
      neonText.style.transition = 'none';
      document.body.style.userSelect = 'none';
    }

    function onMouseMove(e) {
      if (!isDragging) return;
      var dx = e.clientX - start.x;
      var dy = e.clientY - start.y;
      var clamped = clampOffset(dx, dy);
      offset.x = clamped.x;
      offset.y = clamped.y;
      neonText.style.transform = 'translate(' + clamped.x + 'px, ' + clamped.y + 'px)';
    }

    function onMouseUp() {
      if (!isDragging) return;
      isDragging = false;
      neonText.style.cursor = 'grab';
      neonText.style.transition = savedTransition;
      document.body.style.userSelect = '';
    }

    neonText.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    /* Reset position si fenetre redimensionnee (sinon le clamping precedent devient obsolete) */
    window.addEventListener('resize', function () {
      var clamped = clampOffset(offset.x, offset.y);
      offset.x = clamped.x;
      offset.y = clamped.y;
      neonText.style.transform = 'translate(' + clamped.x + 'px, ' + clamped.y + 'px)';
    });
  }

  /* ---------- Fade-in on scroll ---------- */

  function setupFadeIn(root) {
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          root.classList.add('is-visible');
          io.unobserve(root);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
    io.observe(root);
  }

  /* ---------- Detection header offset DESACTIVEE ----------
     Trop variable selon les themes. On utilise un top: 60px hardcode dans le CSS.
     Si besoin de personnaliser, modifier la valeur top dans .lumi-cust-preview du CSS. */
  function detectHeaderOffset(root) {
    /* no-op : on laisse le CSS hardcode top: 60px gerer */
  }

  /* ---------- Date de livraison estimee (today + 10 a +15 jours) ---------- */
  function formatDateLocalized(date, locale) {
    var monthsFr = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    var monthsEn = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var isFr = (locale || 'fr').toLowerCase().indexOf('fr') === 0;
    var months = isFr ? monthsFr : monthsEn;
    if (isFr) {
      return date.getDate() + ' ' + months[date.getMonth()];
    }
    return months[date.getMonth()] + ' ' + date.getDate();
  }

  function updateDeliveryEstimate(root) {
    var el = root.querySelector('[data-lumi-cust-delivery-text]');
    if (!el) return;
    var locale = root.dataset.locale || 'fr';
    var template = root.dataset.i18nDeliveryEstimate || 'Livraison estimée entre le {{ from }} et le {{ to }}';

    var today = new Date();
    var from = new Date(today);
    from.setDate(today.getDate() + 10);
    var to = new Date(today);
    to.setDate(today.getDate() + 15);

    var fromStr = formatDateLocalized(from, locale);
    var toStr = formatDateLocalized(to, locale);
    el.textContent = template.replace('{{ from }}', fromStr).replace('{{ to }}', toStr);
  }

  /* ---------- Boot ---------- */

  function boot() {
    document.querySelectorAll('.lumi-cust[data-lumi-cust-id]').forEach(function (root) {
      initInstance(root);
      setupFadeIn(root);
      setupNeonDrag(root);
      updateDeliveryEstimate(root);
      detectHeaderOffset(root);
      window.addEventListener('resize', function () { detectHeaderOffset(root); });
      /* Debounced detection apres scroll (announce bar peut disparaitre) */
      var scrollTimer;
      window.addEventListener('scroll', function () {
        if (scrollTimer) return;
        scrollTimer = setTimeout(function () {
          detectHeaderOffset(root);
          scrollTimer = null;
        }, 200);
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme Editor : re-init quand la section est re-rendue */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.lumi-cust[data-lumi-cust-id]');
    if (root) initInstance(root);
  });

})();
